import * as PIXI from "pixi.js";
import MiddleLayer from "./MiddleLayer";
import BoxInsideMask from "../entities/BoxInsideMask";
import { EventBus, EnumEventBus } from "../managers/EventBus";

export default class BoxLayer extends PIXI.Container {
  static instance: BoxLayer;
  private MiddleLayer = MiddleLayer.getInstance();
  private EventBus = EventBus;

  constructor() {
    super();
    if (!BoxLayer.instance) {
      BoxLayer.instance = this;
    }
    new BoxInsideMask();
    this.MiddleLayer.addChild(this);

    this.EventBus.on(EnumEventBus.setHowToPlayMode, booleanString => this.visible = !JSON.parse(booleanString))
  }
  static getInstance(): BoxLayer {
    return BoxLayer.instance;
  }
}